<div class="container">
    <div class="row">
        <div class="col-md-6 mt-4">
            <div class="card shadow p-3 mb-5 bg-white rounded">
                <div>
                    <img class="edu-images" src="assets/images/education/annauniv.png" alt="annauniversity">
                    <img class="edu-images float-right" src="assets/images/education/kings.png" alt="prphss">
                </div>
                <div class="card-body">
                    <table style="width:100%">
                        <tr>
                            <th>University</th>
                            <td>Anna University</td>
                        </tr>
                        <tr>
                            <th>College</th>
                            <td>Kings College of Engineering</td>
                        </tr>
                        <tr>
                            <th>Course</th>
                            <td>B.E.(Computer Science and Engineering)</td>
                        </tr>
                        <tr>
                            <th>CGPA</th>
                            <td>6.60</td>
                        </tr>
                        <tr>
                            <th>Year of Passing</th>
                            <td>2018</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-6 mt-4 mb-4">
            <div class="card shadow p-3 mb-5 bg-white rounded">
                <div class="text-center">
                    <img class="edu-images" src="assets/images/education/ponnaiyah.png" alt="PRPHSS">
                </div>
                <div class="card-body">
                    <table style="width:100%">
                        <tr>
                            <th>Board</th>
                            <td colspan="2">State Board</td>
                        </tr>
                        <tr>
                            <th>School</th>
                            <td colspan="2">Ponnaiyah Ramajayam Public Hr.Sec School</td>
                        </tr>
                        <tr>
                            <th>Course</th>
                            <th>%</th>
                            <th>Year of Passing</th>
                        </tr>
                        <tr>
                            <td>HSC</td>
                            <td>79.5</td>
                            <td>2014</td>
                        </tr>
                        <tr>
                            <td>SSLC</td>
                            <td>85.8</td>
                            <td>2012</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>